import React from 'react';

const SystemReleasePage = React.lazy(() => import('pages/SystemRelease/SystemReleasePage'));
const SystemReleaseFormPage = React.lazy(() => import('pages/SystemRelease/SystemReleaseFormPage'));

const systemReleaseRoute = [
  {
    path: '/system-releases',
    exact: true,
    name: 'Quản lý bản cập nhật hệ thống',
    function: 'SYS_SYSTEM_RELEASE_VIEW',
    component: SystemReleasePage,
  },
  {
    path: '/system-releases/add',
    exact: true,
    name: 'Khai báo bản cập nhật hệ thống',
    function: 'SYS_SYSTEM_RELEASE_ADD',
    component: SystemReleaseFormPage,
  },
  {
    path: '/system-releases/edit/:system_release_id',
    exact: true,
    name: 'Chỉnh sửa bản cập nhật hệ thống',
    function: 'SYS_SYSTEM_RELEASE_EDIT',
    component: SystemReleaseFormPage,
  },
  {
    path: '/system-releases/detail/:system_release_id',
    exact: true,
    name: 'Chi tiết bản cập nhật hệ thống',
    function: 'SYS_SYSTEM_RELEASE_VIEW',
    component: SystemReleaseFormPage,
  },
];

export default systemReleaseRoute;
